import { SHIPPING_TYPE } from '@constants/index'
import { UserContext } from '@contexts/user/user.context'
import { IUser } from '@contexts/user/user.utils'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
interface ProductTags {
  data: {
    flags: string[]
    option_prices: {
      [key: string]: {
        shipping_type: string
      }
    }
    shipping_type: string
  }
  selectedSku: number
}

export default function ProductTags({ data, selectedSku }: ProductTags) {
  const selectedOptionPrice = data?.option_prices?.[selectedSku?.toString()]
  const { isHomeBuyer } = useContext(UserContext) as IUser
  const { t } = useTranslation('common')
  return (
    <div className="flex gap-2 justify-start whitespace-nowrap flex-wrap">
      {(data?.shipping_type === SHIPPING_TYPE.SHIPS_FREE ||
        selectedOptionPrice?.shipping_type === SHIPPING_TYPE.SHIPS_FREE) && (
        <FreeShippingTag />
      )}
      {!isHomeBuyer && data?.flags.includes('rebate_eligible') && <RebateTag />}
      {data?.flags.includes('new_arrivals') && <NewArrivalTag />}
      {data?.flags.includes('liquidation') && <ClearanceTag />}
    </div>
  )
}

export function ItemTags({ flags }: ProductTags) {
  // const dataFlags = ['free_shipping']
  const { t } = useTranslation('common')
  return (
    <div className="text-right absolute text-white z-10 font-semibold	text-xs w-[120px] right-0">
      {flags.includes('free_shipping') && (
        <p className="bg-brand-green mb-1 text-center py-[3px]">
          {t('text-free-shipping')}
        </p>
      )}
      {flags.includes('rebate_eligible') && (
        <p className="bg-yellow mb-1 text-center py-[3px]">
          {t('text-rebate-eligible')}
        </p>
      )}
      {flags.includes('new_arrival') && (
        <p className="bg-brand-blue mb-1 text-center py-[3px]">
          {t('text-new-arrivals')}
        </p>
      )}
    </div>
  )
}

export function FreeShippingTag({}: any) {
  const { t } = useTranslation('common')

  return (
    <div className="mb-2 rounded-xl text-brand-green text-sm py-0.5 px-2 font-semibold border border-brand-green">
      {t('text-free-shipping')}
    </div>
  )
}

export function RebateTag({}: any) {
  const { t } = useTranslation('common')

  return (
    <div className="mb-2 rounded-xl text-yellow text-sm py-0.5 px-2 font-semibold border border-yellow">
      {t('text-rebate-eligible')}
    </div>
  )
}

export function NewArrivalTag({}: any) {
  const { t } = useTranslation('common')

  return (
    <div className="mb-2 rounded-xl text-brand-blue text-sm py-0.5 px-2 font-semibold border border-brand-blue">
      {t('text-new-arrivals')}
    </div>
  )
}

export function ClearanceTag({}: any) {
  const { t } = useTranslation('common')

  return (
    <div className="mb-2 rounded-xl text-brand-pink text-sm py-0.5 px-2 font-semibold border border-brand-pink">
      {t('text-liquidation')}
    </div>
  )
}
